<template>
  <div class="col-xs-12">
    <base-card>
      <div class="cart-title pb_30 mb_30">
        <p>Checkout</p>
      </div>
      <div class="payment-container">
        <p class="title mb_25">FORMA DE PAGAMENTO</p>
        <div class="selected-card">
          <div class="brand mr_20">
            <div class="no-brand"></div>
          </div>
          <div class="number">
            <div class="title mb_10">Cartão de crédito</div>
            <div class="card-number">MASTERCARD **** 1234</div>
          </div>
          <div class="change-card">
            <a class="link" @click="$emit('changeCard')">TROCAR</a>
          </div>
        </div>
      </div>
      <div class="modules-container">
        <p class="title">MÓDULOS SELECIONADOS</p>
        <div v-for="(item, i) in items" :key="i" class="cart-item">
          <div class="title">{{ item.name }}</div>
          <div class="price">{{ Utils.convertMoney(item.price) }}</div>
          <div class="remove-button ml_15" @click="removeItem(item)">-</div>
        </div>
      </div>
      <div class="price-container">
        <p class="title">VALOR MENSAL</p>
        <p class="price">{{ Utils.convertMoney(getCartTotal()) }}</p>
      </div>
      <div class="finish-container">
        <base-button
          text="PAGAR AGORA"
          class="w-100"
          @click="$emit('checkout')"
        />
      </div>
    </base-card>
  </div>
</template>
<script>
import Utils from "@/utils";
import BaseTitle from "@/components/Title";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";

export default {
  components: { BaseTitle, BaseButton, BaseCard },
  props: {
    items: { type: Array, default: [] },
    card: { type: Object, default: null },
  },
  data() {
    return {
      Utils,
    };
  },
  methods: {
    getCartTotal() {
      return this.items.reduce((c, i) => c + i.price, 0);
    },
    removeItem(item) {
      this.$emit("removeItem", item);
    },
  },
};
</script>
<style scoped>
.card-title {
  text-align: left;
  font: normal normal 900 16px/19px Lato;
  letter-spacing: 0px;
  color: #777777;
  opacity: 1;
}

.card-description {
  text-align: left;
  font: normal normal 300 14px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}

.card-price {
  text-align: left;
  font: normal normal bold 18px/22px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.card-period {
  text-align: left;
  font: normal normal 300 18px/22px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
  text-transform: lowercase;
}

.card-actions {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.card-actions button {
  flex: 1;
}

.aspect_ratio_16_9 {
  position: relative;
  background-color: #0088dd1a;
}

.aspect_ratio_16_9 .content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.aspect_ratio_16_9::after {
  position: relative;
  display: block;
  content: " ";
  padding-bottom: 56.25%; /* 16:9 -> 9/16 -> 56.25% de altura */
}

.cart-title {
  border-bottom: 0.1px solid var(--label-secondary);
}

.cart-title p {
  text-align: center;
  font: normal normal bold 26px/32px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.payment-container {
  padding-bottom: 35px;
  border-bottom: 0.1px solid var(--label-secondary);
}

.payment-container .title {
  text-align: left;
  font: normal normal 900 14px/17px Lato;
  letter-spacing: 0px;
  color: var(--label-secondary);
  opacity: 1;
}

.modules-container {
  padding-top: 35px;
  padding-bottom: 35px;
  border-bottom: 0.1px solid var(--label-secondary);
}

.modules-container > .title {
  text-align: left;
  font: normal normal 900 14px/17px Lato;
  letter-spacing: 0px;
  color: var(--label-secondary);
  opacity: 1;
}

.modules-container .cart-item {
  padding-top: 20px;
  display: flex;
}

.modules-container .cart-item .title {
  flex: 1;
  text-align: left;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: var(--label-secondary);
  opacity: 1;
}

.modules-container .cart-item .price {
  text-align: left;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.modules-container .cart-item .remove-button {
  background: #dddddd 0% 0% no-repeat padding-box;
  border-radius: 3px;
  opacity: 1;
  color: white;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.price-container {
  padding-top: 35px;
  padding-bottom: 35px;
  border-bottom: 0.1px solid var(--label-secondary);
  text-align: center;
}

.price-container .title {
  text-align: center;
  font: normal normal 300 14px/17px Lato;
  letter-spacing: 0px;
  color: #aaaaaa;
  opacity: 1;
}

.price-container .price {
  text-align: center;
  font: normal normal 900 24px/29px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}

.finish-container {
  padding-top: 35px;
  text-align: center;
}

.payment-container .selected-card .brand .no-brand {
  width: 50px;
  height: 35px;
  background: #eeeeee 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.payment-container .selected-card {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.payment-container .selected-card .number {
  flex: 1;
}

.payment-container .selected-card .number .title {
  text-align: left;
  font: normal normal normal 15px/18px Lato;
  letter-spacing: 0px;
  color: #aaaaaa;
  opacity: 1;
}

.payment-container .selected-card .number .card-number {
  text-align: left;
  font: normal normal normal 12px/15px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
  opacity: 1;
}

.payment-container .selected-card .change-card {
  display: flex;
  align-items: center;
}

.payment-container .selected-card .change-card .link {
  cursor: pointer;
  text-align: left;
  font: normal normal 300 14px/17px Lato;
  letter-spacing: 0px;
  color: var(--default-hover);
  opacity: 1;
}
</style>
